<template>
  <div class="box" @click="sendToSite">
    <div class="box__image" @mouseover="changeText" @mouseleave="backText">
      <img v-if="img === 'img_pg1'" class="img" src="@/assets/rubiks-logo.png" />
      <img v-if="img === 'my_air'" class="img" src="@/assets/myair.png" style="max-height: none;"/>
      <img v-if="img === 'odin'" class="img" src="@/assets/odindm.png" style="max-height: none;margin-bottom: 30px;"/>
      <img v-if="img === 'insightUp'" class="img" src="@/assets/insightup.png" style="max-height: none;"/>
      <img v-if="img === 'cr'" class="img" src="@/assets/carrefour.png" style="max-height: none;"/>
    </div>
    <div class="box__text">
      <span class="box__title">{{ title }}</span>
      <span class="box__dexcription" :id="title">{{ desc }}</span>
      <span class="invitation" :id="title + 'i'">Check my project</span>
    </div>
  </div>
</template>

<style>

</style>

<script>
export default {
  name: "ProjectBox",
  props: {
    title: String,
    desc: String,
    link: String,
    img: {
      type: String,
      default: 'img_pg'
    },
  },
  methods: {
    sendToSite () {
      window.open(this.link,"_blank")
    },
    changeText() {
      document.getElementById(this.title).classList.add('hovered')
      document.getElementById(this.title + 'i').classList.add('hovered')
      document.getElementById(this.title + 'i').style.display = 'block';
    },
    backText() {
      document.getElementById(this.title + 'i').classList.remove('hovered')
      document.getElementById(this.title + 'i').style.display = 'none';
      document.getElementById(this.title).classList.remove('hovered')
    },
  }
};
</script>
<style lang="scss" scoped>
.box {
  border-radius: 10px;
  overflow: hidden;
  height: 100%;
  width: 100%;
  display: flex;
  flex-direction: column;
  border: 1px solid rgb(53, 53, 53);

  &__title {
    font-size: max(calc(100vw/90), calc(100vh/40));
    text-align: center;
    padding: calc(100vh/100);
    font-weight: bold;
  }

  &__dexcription {
    font-size: max(calc(100vw/140), calc(100vh/70));
    text-align: center;
    font-weight: 400;
    width: 100%;

    margin: 0 auto;

    &.hovered {
      height: 0;
      overflow: hidden;
      transition: all .2s ease-in;
    }
  }

  .invitation {
  
    font-size: max(calc(100vw/100), calc(100vh/70));
    text-align: center;
    font-weight: 400;
    width: 20%;
    margin: 0 auto;
    height: 0;
    transition: all .3s ease-in;

    &.hovered {
      height: 100%;
    }
  }

  &__image {
    height: 70%;
    max-height: 70%;
    overflow: hidden;
    text-align: center;

    .img {
      //object-fit: cover;
      transition: .5s ease all;
      max-height: 100%;
      max-width: 100%;

      &:hover {
        transform: scale(1.1);
      }
    }
  }

  &__text {
    border-top: 1px solid rgb(53, 53, 53);
    background: rgba(24, 24, 24, 0.363)00;
    height: 30%;
    display: flex;
    flex-direction: column;

    >* {
      height: 50%;
    }
  }
}


@media only screen and (max-width: 768px) {
  .box {
  border-radius: 10px;
  overflow: hidden;
  height: 25vh;
  width: 100%;
  display: flex;
  flex-direction: column;
  border: 1px solid rgb(53, 53, 53);

  &__title {
    font-size: max(calc(100vw/90), calc(100vh/50));
    text-align: center;
    padding: calc(100vh/100);
    font-weight: bold;
  }

  &__dexcription {
    font-size: max(calc(100vw/140), calc(100vh/80));
    text-align: center;
    font-weight: 400;
    width: 100%;

    margin: 0 auto;

    &.hovered {
      height: 0;
      overflow: hidden;
      transition: all .2s ease-in;
    }
  }

  .invitation {
  
    font-size: max(calc(100vw/100), calc(100vh/70));
    text-align: center;
    font-weight: 400;
    width: 20%;
    margin: 0 auto;
    height: 0;
    transition: all .3s ease-in;

    &.hovered {
      height: 100%;
    }
  }

  &__image {
    height: 70%;
    max-height: 70%;
    overflow: hidden;
    text-align: center;

    .img {
      //object-fit: cover;
      transition: .5s ease all;
      max-height: 100%;
      max-width: 100%;

      &:hover {
        transform: scale(1.1);
      }
    }
  }

  &__text {
    border-top: 1px solid rgb(53, 53, 53);
    background: rgba(24, 24, 24, 0.363)00;
    height: 30%;
    display: flex;
    flex-direction: column;

    >* {
      height: 50%;
    }
  }
}

}
</style>